import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducers from '../redux';
import logger from 'redux-logger';
import rootSaga  from '../sagas/'


const sagaMiddleware = createSagaMiddleware();

const getMiddlewares = () => {
  if (process.env.NODE_ENV === 'development') {
    return [
            logger,
            sagaMiddleware
           ];
  }
  return [sagaMiddleware]
}

const store = createStore(reducers, applyMiddleware(...getMiddlewares()));

sagaMiddleware.run(rootSaga)

export default store;

